import { render, staticRenderFns } from "./InteriorDesignTabTwo.vue?vue&type=template&id=b58c2a56"
var script = {}
import style0 from "./InteriorDesignTabTwo.vue?vue&type=style&index=0&id=b58c2a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports